"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getBulkApplyRuleUuids = getBulkApplyRuleUuids;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _badge = require("@design/ui/badge");
var _button = require("@design/ui/button");
var _card = require("@design/ui/card");
var _item = require("@design/ui/item");
var _spinner = require("@design/ui/spinner");
var _IssueCard = _interopRequireDefault(require("@common/components/issues/IssueCard"));
var _DeviationScoreBar = _interopRequireWildcard(require("@common/components/review/DeviationScoreBar"));
var _RemedyActionPrimitives = require("@common/components/remedy/RemedyActionPrimitives");
var _liveReview = require("@common/schemas/live-review");
var _liveReviewActionState = require("@common/utils/liveReviewActionState");
var _liveReviewOoxml = require("@common/utils/liveReviewOoxml");
var _applyOutcome = require("@common/utils/applyOutcome");
var _appliedActions = require("@common/constants/appliedActions");
var _scrollAnchoring = require("@common/utils/scrollAnchoring");
var _LiveReviewIssueDrawer = _interopRequireDefault(require("./LiveReviewIssueDrawer"));
var _liveReviewExpansionStore = require("./liveReviewExpansionStore");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function getBulkApplyRuleUuids(issues, commentHeldBackReason) {
  return issues.filter(function (i) {
    var _i$remedies$length, _i$remedies, _i$comments;
    return i.stage === "done" && i.match && !i.responded && !i.conceded && (((_i$remedies$length = (_i$remedies = i.remedies) === null || _i$remedies === void 0 ? void 0 : _i$remedies.length) !== null && _i$remedies$length !== void 0 ? _i$remedies$length : 0) > 0 || ((_i$comments = i.comments) !== null && _i$comments !== void 0 ? _i$comments : []).some(function (issueComment) {
      var _commentHeldBackReaso;
      return ((_commentHeldBackReaso = commentHeldBackReason === null || commentHeldBackReason === void 0 ? void 0 : commentHeldBackReason(i, issueComment)) !== null && _commentHeldBackReaso !== void 0 ? _commentHeldBackReaso : null) === null;
    }));
  }).map(function (i) {
    return i.ruleUuid;
  }).filter(function (id) {
    return !!id;
  });
}
var STATUS_BADGE_VARIANT = {
  running: "secondary",
  completed: "success",
  failed: "destructive"
};
function LiveReviewWidget(_ref) {
  var data = _ref.data,
    conversationId = _ref.conversationId,
    messageId = _ref.messageId,
    interactions = _ref.interactions;
  var _useLiveReviewExpansi = (0, _liveReviewExpansionStore.useLiveReviewExpansion)(conversationId, messageId),
    _useLiveReviewExpansi2 = _slicedToArray(_useLiveReviewExpansi, 2),
    isExpanded = _useLiveReviewExpansi2[0],
    setIsExpanded = _useLiveReviewExpansi2[1];
  var containerRef = (0, _react.useRef)(null);
  var headerRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(new Set()),
    _useState2 = _slicedToArray(_useState, 2),
    busyApplyKeys = _useState2[0],
    setBusyApplyKeys = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    openIssueIndex = _useState4[0],
    setOpenIssueIndex = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    segmentFilter = _useState6[0],
    setSegmentFilter = _useState6[1];
  var _useMemo = (0, _react.useMemo)(function () {
      var visible = (0, _liveReview.getVisibleLiveReviewIssues)(data);
      return {
        visibleIssues: visible,
        reviewedCount: visible.filter(function (i) {
          return i.ruleUuid && !_liveReview.UNREVIEWED_ISSUE_STAGES.has(i.stage);
        }).length,
        triggeredCount: visible.filter(function (i) {
          return i.match;
        }).length
      };
    }, [data.generatedAt]),
    visibleIssues = _useMemo.visibleIssues,
    reviewedCount = _useMemo.reviewedCount,
    triggeredCount = _useMemo.triggeredCount;
  var displayIssues = visibleIssues.map(function (issue) {
    return (0, _liveReviewActionState.withLocalActionState)(issue, conversationId, messageId, interactions);
  });
  var bulkApplyRuleUuids = getBulkApplyRuleUuids(displayIssues, interactions === null || interactions === void 0 ? void 0 : interactions.commentHeldBackReason);
  var totalsLabel = (0, _react.useMemo)(function () {
    var total = visibleIssues.length;
    if (data.status === "completed") {
      var unreviewed = total - reviewedCount;
      var notReviewed = unreviewed > 0 ? ", ".concat(unreviewed, " not reviewed") : "";
      return "".concat(triggeredCount, " issue").concat(triggeredCount === 1 ? "" : "s", " triggered (").concat(reviewedCount, " rule").concat(reviewedCount === 1 ? "" : "s", " checked").concat(notReviewed, ")");
    }
    if (total === 0) return "Analyzing rules...";
    return "".concat(total, " rule").concat(total === 1 ? "" : "s", " processing");
  }, [data.generatedAt, data.status]);
  var applyOne = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(issue, kind, payload) {
      var issueId, actionId;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (interactions) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            issueId = (0, _liveReviewOoxml.liveReviewIssueKey)(issue);
            actionId = (0, _liveReviewOoxml.buildActionId)(messageId, issueId, kind, payload.id);
            if (!(interactions.isActionApplied(conversationId, actionId) || busyApplyKeys.has(actionId))) {
              _context.n = 2;
              break;
            }
            return _context.a(2);
          case 2:
            setBusyApplyKeys(function (prev) {
              return new Set(prev).add(actionId);
            });
            _context.p = 3;
            _context.n = 4;
            return (0, _applyOutcome.runRecordedApply)(function () {
              return kind === "remedy" ? interactions.applyRemedy(issue, payload) : interactions.applyComment(issue, payload);
            }, {
              markApplied: function markApplied() {
                return interactions.markActionAsApplied(conversationId, actionId);
              },
              markFailed: function markFailed(reason) {
                return interactions.markActionAsFailed(conversationId, actionId, reason);
              },
              markPartlyApplied: interactions.markActionAsPartlyApplied === undefined ? undefined : function (partlyApplied) {
                var _interactions$markAct;
                return (_interactions$markAct = interactions.markActionAsPartlyApplied) === null || _interactions$markAct === void 0 ? void 0 : _interactions$markAct.call(interactions, conversationId, actionId, (0, _appliedActions.applyFailureReason)(partlyApplied), partlyApplied.message);
              },
              onError: function onError(error) {
                return interactions.onError(error, {
                  component: "LiveReviewWidget",
                  action: "apply_".concat(kind),
                  conversationId: conversationId,
                  messageId: messageId,
                  issueId: issueId
                });
              }
            });
          case 4:
            _context.p = 4;
            setBusyApplyKeys(function (prev) {
              var next = new Set(prev);
              next.delete(actionId);
              return next;
            });
            return _context.f(4);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[3,, 4, 5]]);
    }));
    return function applyOne(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  var isRunning = data.status === "running";
  var statusIcon = data.status === "running" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {
    "data-icon": "inline-start"
  }) : data.status === "completed" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckCircleIcon, {
    "data-icon": "inline-start"
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ErrorIcon, {
    "data-icon": "inline-start"
  });
  function renderIssueRow(issue, filteredIndex) {
    var _issue$remedies, _issue$comments;
    var issueKey = (0, _liveReviewOoxml.liveReviewIssueKey)(issue);
    var primaryRemedy = (_issue$remedies = issue.remedies) === null || _issue$remedies === void 0 ? void 0 : _issue$remedies[0];
    var primaryComment = (_issue$comments = issue.comments) === null || _issue$comments === void 0 ? void 0 : _issue$comments[0];
    var remedyActionId = primaryRemedy ? (0, _liveReviewOoxml.buildActionId)(messageId, issueKey, "remedy", primaryRemedy.id) : null;
    var commentActionId = primaryComment ? (0, _liveReviewOoxml.buildActionId)(messageId, issueKey, "comment", primaryComment.id) : null;
    var remedyApplied = !!interactions && !!remedyActionId && interactions.isActionApplied(conversationId, remedyActionId);
    var remedyDismissed = !!interactions && !!remedyActionId && interactions.isActionDismissed(conversationId, remedyActionId);
    var remedySupersededBy = !!interactions && !!remedyActionId ? interactions.getActionSupersession(conversationId, remedyActionId) : undefined;
    var remedyPartlyAppliedReason = remedyActionId && interactions !== null && interactions !== void 0 && interactions.partlyAppliedReasonOf ? interactions.partlyAppliedReasonOf(conversationId, remedyActionId) : null;
    var commentState = interactions && primaryComment ? (0, _liveReviewActionState.issueCommentStateOf)(issue, primaryComment, commentActionId, remedyActionId, conversationId, interactions) : null;
    var showApplyRow = !!interactions && issue.stage === "done" && !!(primaryRemedy || primaryComment);
    function renderRemedySlot() {
      if (!primaryRemedy) return null;
      if (remedyDismissed) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyDismissedIndicator, {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        isSaving: false
      });
      if (remedyPartlyAppliedReason !== null) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyPartlyAppliedIndicator, {
        reason: remedyPartlyAppliedReason
      });
      if (remedyApplied) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyAppliedIndicator, {});
      if (remedySupersededBy) {
        var superseder = (0, _liveReviewActionState.supersedingIssueViewOf)(remedySupersededBy, displayIssues, listedIssues, setOpenIssueIndex);
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedySupersededIndicator, {
          supersededBy: superseder.label,
          onShowSuperseder: superseder.onShow
        });
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyApplyButton, {
        label: "Apply redline",
        isLoading: !!remedyActionId && busyApplyKeys.has(remedyActionId),
        disabled: !!remedyActionId && busyApplyKeys.has(remedyActionId),
        onClick: function onClick() {
          return applyOne(issue, "remedy", primaryRemedy);
        },
        "data-sentry-element": "RemedyApplyButton",
        "data-sentry-component": "renderRemedySlot",
        "data-sentry-source-file": "LiveReviewWidget.tsx"
      });
    }
    function renderCommentSlot() {
      if (!primaryComment || commentState === null) return null;
      var addCommentButton = /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyApplyButton, {
        label: "Add comment",
        isLoading: !!commentActionId && busyApplyKeys.has(commentActionId),
        disabled: !!commentActionId && busyApplyKeys.has(commentActionId),
        onClick: function onClick() {
          return applyOne(issue, "comment", primaryComment);
        }
      });
      switch (commentState.kind) {
        case "dismissed":
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyDismissedIndicator, {
            onClick: function onClick(e) {
              return e.stopPropagation();
            },
            isSaving: false
          });
        case "applied":
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyAppliedIndicator, {});
        case "heldBack":
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyHeldBackIndicator, {
            heldBackReason: commentState.heldBackReason
          });
        case "failed":
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [addCommentButton, /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyFailedIndicator, {
              reason: commentState.failureReason
            })]
          });
        case "pending":
          return addCommentButton;
      }
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-col gap-1",
      "data-sentry-component": "renderIssueRow",
      "data-sentry-source-file": "LiveReviewWidget.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IssueCard.default, {
        issue: issue,
        filteredIndex: filteredIndex,
        onClick: function onClick() {
          return setOpenIssueIndex(filteredIndex);
        },
        "data-sentry-element": "IssueCard",
        "data-sentry-source-file": "LiveReviewWidget.tsx"
      }), showApplyRow ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex justify-end gap-1.5",
        children: [renderRemedySlot(), renderCommentSlot()]
      }) : null]
    }, issueKey);
  }
  function renderApplyAllButton() {
    if (!interactions) return null;
    if (interactions.isApplyingAll) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyApplyButton, {
        label: "Apply all",
        showIcon: false,
        isLoading: true,
        disabled: true
      });
    }
    if (interactions.hasAppliedAll) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyApplyButton, {
        label: "Applied",
        showIcon: false,
        disabled: true
      });
    }
    if (bulkApplyRuleUuids.length === 0) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyApplyButton, {
      label: "Apply all",
      showIcon: false,
      onClick: function onClick() {
        return interactions.onApplyAll(bulkApplyRuleUuids);
      },
      "data-sentry-element": "RemedyApplyButton",
      "data-sentry-component": "renderApplyAllButton",
      "data-sentry-source-file": "LiveReviewWidget.tsx"
    });
  }
  var showApplyAllRow = !!interactions && !isRunning && (bulkApplyRuleUuids.length > 0 || interactions.hasAppliedAll);
  function renderApplyAllRow() {
    if (!showApplyAllRow) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_item.Item, {
      variant: "muted",
      size: "xs",
      "data-sentry-element": "Item",
      "data-sentry-component": "renderApplyAllRow",
      "data-sentry-source-file": "LiveReviewWidget.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemContent, {
        "data-sentry-element": "ItemContent",
        "data-sentry-source-file": "LiveReviewWidget.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_item.ItemDescription, {
          "data-sentry-element": "ItemDescription",
          "data-sentry-source-file": "LiveReviewWidget.tsx",
          children: [reviewedCount, " issue", reviewedCount === 1 ? "" : "s", " reviewed"]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemActions, {
        "data-sentry-element": "ItemActions",
        "data-sentry-source-file": "LiveReviewWidget.tsx",
        children: renderApplyAllButton()
      })]
    });
  }
  var listedIssues = segmentFilter ? displayIssues.filter(function (issue) {
    return (0, _DeviationScoreBar.matchesDeviationSegment)(issue, segmentFilter);
  }) : displayIssues;
  function setExpandedKeepingHeaderInPlace(nextIsExpanded) {
    (0, _scrollAnchoring.keepAnchorInPlaceThroughNextResize)(headerRef.current, containerRef.current);
    setIsExpanded(nextIsExpanded);
  }
  var onSegmentClick = function onSegmentClick(segment) {
    setOpenIssueIndex(null);
    setSegmentFilter(function (prev) {
      return prev === segment ? null : segment;
    });
    setExpandedKeepingHeaderInPlace(true);
  };
  var deviationBar = (0, _DeviationScoreBar.hasResolvedIssues)(displayIssues) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardContent, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeviationScoreBar.default, {
      issues: displayIssues,
      onSegmentClick: onSegmentClick,
      isCollapsed: !isExpanded,
      activeSegment: segmentFilter,
      showLegend: true
    })
  }) : null;
  function renderSegmentFilterRow() {
    if (!segmentFilter) return null;
    var summary = listedIssues.length === 0 ? "No ".concat((0, _DeviationScoreBar.deviationSegmentName)(segmentFilter), " rules left") : "Showing ".concat((0, _DeviationScoreBar.deviationSegmentLabel)(segmentFilter, listedIssues.length));
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_item.Item, {
      variant: "muted",
      size: "xs",
      "data-sentry-element": "Item",
      "data-sentry-component": "renderSegmentFilterRow",
      "data-sentry-source-file": "LiveReviewWidget.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemContent, {
        "data-sentry-element": "ItemContent",
        "data-sentry-source-file": "LiveReviewWidget.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemDescription, {
          "data-sentry-element": "ItemDescription",
          "data-sentry-source-file": "LiveReviewWidget.tsx",
          children: summary
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemActions, {
        "data-sentry-element": "ItemActions",
        "data-sentry-source-file": "LiveReviewWidget.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
          type: "button",
          variant: "link",
          size: "xs",
          onClick: function onClick() {
            return onSegmentClick(segmentFilter);
          },
          "data-sentry-element": "Button",
          "data-sentry-source-file": "LiveReviewWidget.tsx",
          children: "Show all rules"
        })
      })]
    });
  }
  var drawer = openIssueIndex !== null && listedIssues[openIssueIndex] ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_LiveReviewIssueDrawer.default, {
    issue: listedIssues[openIssueIndex],
    filteredIndex: openIssueIndex,
    visibleIssues: listedIssues,
    reviewIssues: displayIssues,
    playbookName: data.playbookName,
    conversationId: conversationId,
    messageId: messageId,
    onClose: function onClose() {
      return setOpenIssueIndex(null);
    },
    interactions: interactions
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.Card, {
    ref: containerRef,
    size: "sm",
    className: "my-2",
    "data-sentry-element": "Card",
    "data-sentry-component": "LiveReviewWidget",
    "data-sentry-source-file": "LiveReviewWidget.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardHeader, {
      "data-sentry-element": "CardHeader",
      "data-sentry-source-file": "LiveReviewWidget.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.Item, {
        size: "xs",
        asChild: true,
        "data-sentry-element": "Item",
        "data-sentry-source-file": "LiveReviewWidget.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          ref: headerRef,
          type: "button",
          onClick: function onClick() {
            return setExpandedKeepingHeaderInPlace(!isExpanded);
          },
          "aria-expanded": isExpanded,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemMedia, {
            variant: "icon",
            "data-sentry-element": "ItemMedia",
            "data-sentry-source-file": "LiveReviewWidget.tsx",
            children: isExpanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {})
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_item.ItemContent, {
            "data-sentry-element": "ItemContent",
            "data-sentry-source-file": "LiveReviewWidget.tsx",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemTitle, {
              "data-sentry-element": "ItemTitle",
              "data-sentry-source-file": "LiveReviewWidget.tsx",
              children: data.playbookName || "Playbook Review"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemDescription, {
              "data-sentry-element": "ItemDescription",
              "data-sentry-source-file": "LiveReviewWidget.tsx",
              children: totalsLabel
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemActions, {
            "data-sentry-element": "ItemActions",
            "data-sentry-source-file": "LiveReviewWidget.tsx",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_badge.Badge, {
              variant: STATUS_BADGE_VARIANT[data.status],
              "data-sentry-element": "Badge",
              "data-sentry-source-file": "LiveReviewWidget.tsx",
              children: [statusIcon, data.status]
            })
          })]
        })
      })
    }), deviationBar, isExpanded ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardContent, {
      children: [renderSegmentFilterRow(), renderApplyAllRow(), listedIssues.map(function (issue, filteredIndex) {
        return renderIssueRow(issue, filteredIndex);
      }), renderApplyAllRow()]
    }) : null, drawer]
  });
}
var _default = exports.default = LiveReviewWidget;